/* eslint-disable react/no-children-prop */
import React from 'react';
import ModalWrapper from 'Common/Components/ModalWrapper';
import useKeyPress from 'Hooks/useKeyPress';
import {
  ModalTitle,
  Title,
  BodyText,
  ModalContent,
  ButtonsContainer,
  ConfirmButton,
  CancelButton,
  Warning,
  ModalBody,
  VulnerabilityList,
  VulnerabilityItem
} from './styled';

const UngroupConfirmationModal = ({
  show,
  onCancel,
  onConfirm,
  groupName,
  selectedVulnNames = [],
  loading = false
}) => {
  const groupLabel = groupName || 'this group';
  const hasSelectedVulns = selectedVulnNames.length > 0;
  const title = hasSelectedVulns ? 'Ungroup Selected Vulnerabilities' : 'Delete Group';
  const confirmLabel = hasSelectedVulns ? 'Ungroup Selected' : 'Delete Group';

  useKeyPress(() => {
    if (!show || loading) return;
    onCancel();
  }, ['Escape'], show && !loading);

  useKeyPress(() => {
    if (!show || loading) return;
    onConfirm();
  }, ['Enter'], show && !loading);

  if (!show) return null;

  return (
    <ModalWrapper>
      <ModalContent>
        <ModalTitle>
          <Warning />
          <Title>{title}</Title>
        </ModalTitle>
        <ModalBody>
          {hasSelectedVulns
            ? (
              <>
                <BodyText>
                  <span children={ "You're about to ungroup the following vulnerabilities from " } />
                  <span style={ { fontWeight: 600 } } children={ groupLabel } />
                  <span children={ ". This action can't be undone. Are you sure you want to proceed?" } />
                </BodyText>
                <VulnerabilityList>
                  {selectedVulnNames.map((name, index) => (
                    <VulnerabilityItem key={ `${name}-${index}` }>{name}</VulnerabilityItem>
                  ))}
                </VulnerabilityList>
              </>
              )
            : (
              <BodyText>
                <span children={ "You're about to delete " } />
                <span style={ { fontWeight: 600 } } children={ groupLabel } />
                <span children={ ". All vulnerabilities in this group will be ungrouped. This action can't be undone. Are you sure you want to proceed?" } />
              </BodyText>
              )}
        </ModalBody>
        <ButtonsContainer>
          <CancelButton onClick={ onCancel } disabled={ loading }>Cancel</CancelButton>
          <ConfirmButton onClick={ onConfirm } disabled={ loading } $isLoading={ loading }>{confirmLabel}</ConfirmButton>
        </ButtonsContainer>
      </ModalContent>
    </ModalWrapper>
  );
};

export default UngroupConfirmationModal;
